import { ResponsiveView, ResponsiveSizeContainer, FixedSizeFitContainer, FixedSizeCoverContainer } from "../../../singlegame/ResponsiveHelpers";
import { Track } from "../../AudioManager";
import { Log, CreateSpineResources, Scale, Delay } from "../../MyHelpers";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Presentation, Settings } from "../../Settings";
import { ITransitionParamsPIXIAPP } from "./ITransitionFactoryPIXIAPP";
import { TRANSITION_SIZE, TransitionAnimationSpineResponsive } from "./TransitionAnimationSpineResponsive";
import * as PIXI from 'pixi.js'
import gsap from "gsap";

export class RapidLinkResponsivePIXITransition extends TransitionAnimationSpineResponsive {

    public constructor(params: ITransitionParamsPIXIAPP) {
        super(params);
    }

    public override async PrepareResources(resourceManager?: IWriteOnlyResourceManager): Promise<void> {
        resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/Jackpot${this.jackpotName}/SpineResources/TransitionSpine/FireBall.json`, this.resid.ScopedResourceName(`TransitionAnimationSpineJSON`)));
        resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/Jackpot${this.jackpotName}/SpineResources/TransitionSpine/FireBall.atlas`, this.resid.ScopedResourceName(`TransitionAnimationSpineATLAS`)));

        if (this.params.bonusName == "FreeGameBonus") {
            //create Title Freegames Spine
            resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/Jackpot${this.jackpotName}/SpineResources/FreeGamesBonusSpineTitle/FreeGamesTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleJson`)));
            resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/Jackpot${this.jackpotName}/SpineResources/FreeGamesBonusSpineTitle/FreeGamesTitle.atlas`, ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleAtlas`)));
            //Prepare Sound Transition Title 
            this.params.audio.AddTrack(new Track(this.params.bonusCommonPath + "resources/tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("TitleTransition-Audio")));
        }
        else {
            this.params.audio.AddTrack(new Track(this.params.bonusCommonPath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/tracks/" + this.jackpotName + Settings.audioFormat, this.resid.ScopedResourceName("TitleTransition-Audio")));
        }
    }

    public override ShowTransiton(): void {
        if (this.started == false) {

            this.spine.state.setAnimation(0, "animation", false);
            this.started = true;

            if (this.titleSpine != null) gsap.to(this.titleSpine, {
                duration: 1, alpha: 1, onComplete: () => {
                    this.titleSpine.state.setAnimation(0,"idle", false);
                    this.params.audio.Play(this.resid.ScopedResourceName("TitleTransition-Audio"));
                    //this.params.audio.Play(this.resid.ScopedResourceName("TitleTransition-Audio"));
                }
            });
            if (this.TitlePIXIAnimatedSprite != null) gsap.to(this.TitlePIXIAnimatedSprite, {
                duration: 1, alpha: 1, onComplete: () => {
                    //this.params.audio.Play(this.resid.ScopedResourceName("TitleTransition-Audio"));
                }
            });



            if (this.titleSpine != null) gsap.to(this.titleSpine, { duration: 0.5, alpha: 0 })
            if (this.TitlePIXIAnimatedSprite != null) gsap.to(this.TitlePIXIAnimatedSprite, { duration: 0.5, alpha: 0 })
            setTimeout(() => {
                this.OnTransitionEnded()
            }, 3000);
        }
    }

        public override OnResize(): void {
        if (!this.created) return;

        this.setToDefault();

        this.spine.pivot.set(TRANSITION_SIZE.Width / 2, (TRANSITION_SIZE.Height / 3) * 2);

        this.containertransitionViewApp?.setAvailableSize(window.innerWidth, window.innerHeight);
        this.transitionBackgroundContainer?.setAvailableSize(window.innerWidth, window.innerHeight);



        if (this.TitlePIXIAnimatedSprite) {
            // const scale = Math.min(scaleX, scaleY);this.transitionBackgroundContainer
            // this.TitlePIXIAnimatedSprite.scale.set(scale);
            this.TitlePIXIAnimatedSprite.position.x = (this.transitionFixedContainer.fixedWidth - this.TitlePIXIAnimatedSprite.width) / 2;
            this.TitlePIXIAnimatedSprite.position.y = (this.transitionFixedContainer.fixedHeight - this.TitlePIXIAnimatedSprite.height) / 2;
        }
        if (this.titleSpine) {
            // const scaleX = TRANSITION_SIZE.Width / 1280;
            // const scaleY = TRANSITION_SIZE.Height / 720;
            // const scale = Math.min(scaleX, scaleY);
            // this.titleSpine.scale.set(scale, scale);
            //center title spine using scale
            // this.titleSpine.position.x = (this.transitionFixedContainer.fixedWidth - this.titleSpine.width) / 2;
            this.titleSpine.position.y = (this.transitionFixedContainer.fixedHeight - this.titleSpine.height) / 2;
        }

        this.spine.position.x = this.transitionBackgroundFixedContainer.fixedWidth / 2;//(this.transitionBackgroundFixedContainer.fixedWidth / 2 - (TRANSITION_SIZE.Width) / 2);
        this.spine.position.y = 0;//this.transitionBackgroundFixedContainer.fixedHeight / 2;///(this.transitionBackgroundFixedContainer.fixedHeight - TRANSITION_SIZE.Height) / 2;


    }
}